import { Box } from '@mui/material'
import { Permissions } from 'c1gen/permissions'
import { C1Button, C1ButtonProps, C1LoadingButton } from 'c1ui'
import { usePermissionChecker } from 'components/no-ui/capability'
import React from 'react'
import { FormattedMessage } from 'react-intl'

export type EditSaveProps = {
  editable: boolean,
  permission: Permissions,
  inProgress?: boolean,
  onEditClick: () => void,
  onCancelClick: () => void,
  onSaveClick?: () => void,
  saveDisabled?: boolean,
  editDisabled?: boolean,
  editButtonVariant?: C1ButtonProps['variant']
  editButtonLabel?: C1ButtonProps['children']
}

export const EditSave: React.FC<EditSaveProps> = ({
    editable,
    permission,
    inProgress,
    onEditClick,
    onCancelClick,
    onSaveClick,
    saveDisabled,
    editDisabled,
    editButtonVariant = 'text',
    editButtonLabel,
}) => {
    const hasPermission = usePermissionChecker()

    if (!hasPermission(permission)) {
        return null
    }

    if (editable || inProgress) {
        return <Box display="flex" alignItems="center">
            <Box mr={1}>
                <C1Button
                    variant="text"
                    onClick={onCancelClick}
                    disabled={inProgress}
                    aria-disabled={inProgress}
                    sx={{
                        opacity: inProgress ? 0 : 1,
                        transition: 'opacity 0.2s ease-in-out',

                        '&.Mui-disabled': {
                            backgroundColor: inProgress ? 'transparent' : 'inherit',
                        },
                    }}
                >
                    <FormattedMessage id="component_edit_save_cancel" defaultMessage="Cancel" />
                </C1Button>
            </Box>
            <Box>
                <C1LoadingButton loading={inProgress} variant="contained" onClick={onSaveClick} disabled={saveDisabled} type="submit">
                    <FormattedMessage id="component_edit_save_save" defaultMessage="Save" />
                </C1LoadingButton>
            </Box>
        </Box>
    }

    return <C1Button variant={editButtonVariant} onClick={onEditClick} disabled={editDisabled}>
        {editButtonLabel || <FormattedMessage id="component_edit_save_edit" defaultMessage="Edit" />}
    </C1Button>
}
